module.exports = __webpack_public_path__ + "media/styles/images/svg/circle-ex-gray-dark-433bd63ae81418ba71e97155b99123a0.svg";